/**
 * Device kind — the product category of a physical unit.
 *
 * Shared by mqtt (topic product segment), events (registry mirror sync), and
 * internal (device init). Deliberately lives in common/ so those layers never
 * import from rest/. Mirrors device_status.kind and device_registry.kind
 * CHECK constraints.
 */
import { z } from 'zod';
export const DeviceKindSchema = z.enum(['stair', 'ceiling', 'lift']);
//# sourceMappingURL=device-kind.js.map